import { useEffect, useState } from "react";

export interface UseActiveLanguageResult {
    activeLang: string;
    setActiveLang: (lang: string) => void;
}

/*
* Язык, на котором сейчас правят локализованные поля формы. Один на всю форму, а не на
* поле: переключатель один, а полей под ним может быть сколько угодно.
* Раскладку хук не навязывает — форма сама решает, где показать LanguageSegmentedControl:
* у позиции он в шапке карточки, в модалке категории — над полем.
* */
export const useActiveLanguage = (
    primaryLang: string,
    languages: string[]
): UseActiveLanguageResult => {
    const [activeLang, setActiveLang] = useState<string>(primaryLang);

    // Языки меню приезжают асинхронно и могут смениться в настройках меню: если активный
    // из списка пропал, форма осталась бы редактировать невидимый перевод.
    useEffect(() => {
        if (languages.length === 0 || languages.includes(activeLang)) return;

        setActiveLang(languages.includes(primaryLang) ? primaryLang : languages[0]);
    }, [languages, activeLang, primaryLang]);

    return { activeLang, setActiveLang };
};
